export default {
  app: {
    name: '制造平台'
  },
  brand: {
    mission: '共享、普惠、零碳的未来出行'
  },
  nav: {
    section: {
      vehicle: '整车',
      ccu: '中控',
      tools: '工位软件',
      firmware: '固件',
      codes: '编码',
      admin: '管理'
    },
    dashboard: '概览',
    flashRecords: '烧录记录',
    acceptanceRecords: '验收记录',
    ccuIdentity: 'CCU 身份',
    ccuDevices: '已验收 CCU',
    shipmentCheck: 'CCU 清单核对',
    shipmentManifests: 'CCU 清单核对记录',
    vehicleBindings: '车辆绑定',
    vehicleCommands: '车辆指令',
    checkItems: '检测项',
    standards: '验收标准',
    vehicleModels: '车型',
    skus: 'SKU 管理',
    toolDownloads: '下载',
    toolReleases: '版本发布',
    firmwareDownloads: '固件下载',
    firmwareReleases: '固件发布',
    stockIssuance: '生成编码',
    legacyCodes: '老系统码库',
    organisations: '工厂',
    roles: '角色',
    operators: '操作员',
    chirpCredential: '车辆通信凭证',
    sops: '作业指导书',
    sop: '作业指导书',
    openMenu: '打开导航',
    closeMenu: '关闭导航'
  },
  chirp: {
    title: '车辆通信凭证',
    subtitle: '本服务与车辆通信所用的凭证。开发者凭证在这里铸造，用铸造人自己的账号；工厂凭证属于 Chirp 服务账号，由服务端自动登录并续期，自动登录失败时可在这里手动登录。',
    loadFailed: '无法读取凭证状态。',
    session: 'Chirp 服务账号',
    sessionSignedIn: '已登录：{account}',
    sessionNone: '未登录',
    sessionBy: '登录方式',
    sessionAutomatic: '服务端自动登录',
    sessionManual: '{name} 手动登录',
    sessionUntil: '有效至（UTC）',
    sessionNoPassword: '本部署没有配置服务账号密码，只能手动登录。',
    sessionFailed: '最近一次自动登录失败（{at}）：{reason}',
    factoryUntil: '工厂凭证有效至（UTC）',
    factoryNone: '尚未签发，第一台在工厂窗口内的车需要通信时自动签发',
    signIn: '手动登录',
    signInHint: '会打开 Cloudflare 登录页。请在无痕窗口中用 Chirp 服务账号登录，不要用你自己的账号。',
    signedIn: '已登录，服务端会用这个会话继续工作。',
    inUse: '当前使用中',
    none: '当前没有在用的凭证。没有凭证覆盖的车辆，只能通过本部署配置的凭证通信（如果配置了）。',
    role: {
      developer: '开发者凭证',
      factory: '工厂凭证'
    },
    vehicles: '覆盖车辆',
    factoryVehicles: '处于工厂窗口内的所有车辆（窗口从在 Chirp 登记时开始）',
    expiresAt: '过期时间（UTC）',
    mintedBy: '铸造人',
    handle: '吊销凭据',
    revoke: '立即吊销',
    revoked: '已吊销。在铸造覆盖这些车辆的新凭证前，无法与它们通信。',
    minted: '凭证已铸造并投入使用。',
    interrupted: '操作在完成前被中断，没有生成凭证。请重试。',
    waitingTitle: '等待登录',
    waiting: '已为你打开登录页，请在其中完成登录：铸造时用你自己的邮箱，手动登录服务账号时用服务账号。完成后本页面会自动更新，请保持打开。如果没有自动打开，请点击下方按钮。',
    openAgain: '重新打开登录页',
    minting: '已登录，正在铸造。',
    failedTitle: '上次操作没有成功',
    quotaAdvice: '你的账号同时有效的开发者凭证已达上限。请先吊销一份你自己的，然后重试。',
    mintFirst: '铸造凭证',
    mintAnother: '为更多车辆添加凭证',
    imeiPlaceholder: '每行一个 IMEI',
    imeiHint: '已录入 {count} 台车。只用于不在工厂窗口内的车；窗口内的车由工厂凭证覆盖。',
    mint: '铸造',
    mintHint: '铸造会打开登录页，请用你自己的邮箱登录。凭证算在你自己的配额里，服务账号只负责工厂凭证。',
    account: '所属账号'
  },
  product: {
    category: {
      S: '滑板车',
      E: '电助力自行车',
      G: 'Glider'
    },
    models: {
      title: '车型',
      subtitle: 'SKU 是哪个项目的衍生。',
      create: '新建车型',
      createTitle: '新建车型',
      editTitle: '编辑车型',
      name: '车型',
      code: '项目代码',
      category: '类别',
      frameSegment: '车架号第 4-6 位',
      frameSegmentPlaceholder: '例如 046',
      frameSegmentInvalid: '必须是三位数字，例如 046。前导零有意义。',
      framePreview: '在 {factory} 工厂装配时，该车型的车架号形如：',
      description: '说明',
      state: '状态',
      stateEnabled: '在用',
      stateDisabled: '已停用',
      nameRequired: '请填写车型名称。',
      codeRequired: '请填写项目代码。',
      codeLocked: '项目代码不能修改：已有 {count} 个 SKU 是该车型的衍生，它们按代码引用它。',
      actions: '操作',
      edit: '编辑',
      enable: '恢复使用',
      disable: '停用',
      enabled: '该车型已恢复使用。',
      disabled: '该车型已停用。',
      disableConfirm: '停用 {name}？之后新建 SKU 无法再选它。已有的 {count} 个 SKU 以及据此生产的一切都不受影响。',
      disableConfirmTitle: '停用该车型',
      cancel: '取消',
      save: '保存',
      saved: '已保存。',
      empty: '还没有车型。',
      loadFailed: '车型列表加载失败。'
    },
    powerType: {
      PEDAL_ONLY: '仅脚踏',
      THROTTLE_ONLY: '仅转把',
      PEDAL_AND_THROTTLE: '脚踏 + 转把'
    },
    skus: {
      title: 'SKU 管理',
      subtitle: '每个车型应当由哪些零件装成。',
      create: '新建 SKU',
      createTitle: '新建 SKU',
      editTitle: '编辑 SKU',
      search: '搜索',
      searchPlaceholder: 'SKU 编码或说明',
      anyState: '全部状态',
      stateEnabled: '在用',
      stateDisabled: '已停用',
      standard: '验收标准',
      standardNone: '未选择',
      standardDraft: '可修改',
      standardTitle: '{code} 的验收标准',
      standardHint: '从已配置的标准版本里选一个。标着“可修改”的还没判定过车辆，所以仍能改；第一台在它下面受检的车会把它定下来。',
      standardItemCount: '{count} 项检查',
      standardEmpty: '还没有配置任何标准。',
      standardLoadFailed: '标准列表加载失败。',
      standardSaved: '验收标准已更新。',
      configureStandard: '配置验收标准',
      componentWithdrawn: '已停用',
      qrCaption: '打印后在三码绑定时扫码。',
      model: '车型',
      anyModel: '全部车型',
      modelRequired: '请选择该 SKU 属于哪个车型。',
      code: 'SKU',
      codePlaceholder: 'LPN-XXXXXX',
      descriptionExampleLabel: '例如：',
      descriptionExample: 'Asy, Parrot Ebike E5.1, Israel',
      description: '说明',
      maxSpeed: '配置限速',
      maxSpeedPlaceholder: '例如 25',
      maxSpeedInvalid: '配置限速必须是大于零的数字。该车型没有限速要求时请留空。',
      kph: 'km/h',
      powerType: '驱动方式',
      notSpecified: '未指定',
      vin: 'VIN',
      requiresVin: '该车型带 VIN',
      vinYes: '带',
      vinNo: '不带',
      state: '状态',
      components: '零件数',
      configuration: '默认配置',
      expectedBuild: '零件清单',
      buildHint: '默认全选 —— 取消勾选这个车型没有的零件。清单整体保存，取消勾选即移除。零件的版本要求属于验收标准，不在这里填。',
      noComponents: '还没有填写零件。',
      codeRequired: '请填写 SKU 编码。',
      actions: '操作',
      edit: '编辑',
      enable: '恢复使用',
      disable: '停用',
      enabled: '该车型已恢复使用。',
      disabled: '该车型已停用。',
      disableConfirm: '停用 {code}？之后新的生产订单将无法使用它，已生产的一切不受影响。',
      disableConfirmTitle: '停用该 SKU',
      cancel: '取消',
      save: '保存',
      saved: '已保存。',
      empty: '没有匹配的 SKU。',
      loadFailed: 'SKU 列表加载失败。',
      detailLoading: '正在加载零件清单…',
      detailFailed: '零件清单加载失败。'
    }
  },
  login: {
    heading: '登录',
    subheading: '内部人员使用 Google 登录。',
    googleUnconfigured: '当前环境未配置 Google 登录。设置 VITE_GOOGLE_CLIENT_ID 后可用。',
    googleUnavailable: 'Google 登录加载失败，请检查网络后重试。',
    supplierToggle: '供应商登录',
    supplierHint: '供无法使用 Google 的工厂账号使用。',
    username: '用户名',
    password: '密码',
    rememberMe: '在本工位保持登录',
    submit: '登录',
    backToGoogle: '返回 Google 登录',
    signingIn: '登录中…'
  },
  session: {
    signOut: '退出登录',
    expired: '登录已失效，请重新登录。',
    role: '角色',
    permissions: '权限'
  },
  dashboard: {
    heading: '概览',
    subtitle: '每个工位做了多少、良率怎么走、以及哪些事需要人来处理。',
    station: {
      ccu: 'CCU EOL',
      ccuScope: '只统计 CCU 模块：两个 CCU 工位记录的全部检测。这里没有任何一个数字是关于整车的。',
      vehicle: 'Vehicle EOL',
      vehicleScope: '整车检测。等整车工位接入这个服务之后在这里统计。'
    },
    vehicle: {
      kpi: {
        vehicles: '受检车辆',
        vehiclesHint: '去重车辆数。背后是 {attempts} 次检测，同一台车做完两种检测只算一台。',
        aborted: '中止',
        abortedHint: '检测没给出结论就停了。既不是缺陷，也不是环境故障。'
      },
      waiting: {
        title: '仍在等待',
        hint: '这些是实际停在某处的车，不是比率。一台车不管失败几次都只算一次。',
        awaitingRetest: '等待复检',
        suspectedMisBindings: '疑似错绑',
        misBindingHint:
          '疑似错绑指的是操作员动了车、车却一直没有应答。它被刻意与组件分开统计：如果按组件缺陷记录，就会把好零件送去返修，而真正错绑的那一对还留在线上。'
      },
      testType: {
        STATIC: '静态检测',
        RIDE: '骑行检测'
      },
      trendHint:
        '两种检测合在一起。骑行检测只在静态检测通过后才做，拆成两条线会让人把这个先后差读成下跌。绝不要和 CCU 的趋势相加。',
      checkParetoHint: '哪个检测项失败最多。这是「要修什么」。',
      componentPareto: {
        title: '按组件统计失败',
        hint: '失败落在哪个零件上。这是「找谁谈」。组件的总数包含了没进上面前几名的检测项，所以两张图不会相加相等。'
      },
      paretoDetail: '{failures} 次失败 · {vehicles} 台车 · 占窗口内 {share}',
      noComponent: '未指定组件'
    },
    window: {
      days: '{days} 天'
    },
    windowCaption: '{from} 至 {to}（UTC）',
    refresh: '刷新',
    loadFailed: '这部分数据没能加载出来。',
    retry: '重试',
    noFigures: '这个账号没有可看的生产数据。左侧导航列出了它能进入的页面。',
    kpi: {
      modules: '受检模块',
      modulesHint: '共 {attempts} 次检测，含复检',
      firstPassYield: '一次通过率',
      firstPassYieldHint: '首次检测 {attempts} 次，其中 {passes} 次通过',
      rejected: '判定不合格',
      rejectedHint: '模块未达到验收标准的检测',
      infraErrors: '中断',
      infraErrorsHint: '被模块以外的原因打断，因此不计入不良'
    },
    trend: {
      title: '一次通过率',
      hint: '柱子是每天的检测次数，折线是一次通过率。断开的地方表示那天没有检测；今天是不完整的一天，所以最后一个点通常最低。',
      attempts: '检测次数',
      yield: '一次通过率',
      empty: '这段时间内没有检测过任何 CCU 模块。'
    },
    stages: {
      OUTGOING: '出货检（模块供应商）',
      INCOMING: '来料检（整车厂）',
      yield: '一次通过率',
      modules: '模块数',
      attempts: '检测次数',
      rejected: '判定不合格'
    },
    pareto: {
      title: '失败集中在哪里',
      hint: 'CCU 检测项里失败次数最多的几项。完全读不到值的检测项不计入这里——那是工位的问题，不是模块的不良。',
      failures: '失败次数',
      detail: '失败 {failures} 次 · {modules} 个模块 · 占全部失败的 {share}',
      empty: '这段时间内没有检测项失败。'
    },
    identity: {
      title: 'CCU 云端身份注册',
      hint: '只在 CCU 工位采集。不受上方时间范围限制：积压不会因为放久了就不算积压。',
      pending: '等待中',
      inProgress: '进行中',
      registered: '已注册',
      failed: '已放弃',
      oldestPending: '最久的一条从 {at}（UTC）起就在等。',
      nothingPending: '没有等待中的记录。'
    },
    attention: {
      title: '需要处理',
      clear: '没有需要处理的事。',
      identityFailed: '{count} 个模块已用完注册重试次数，在有人介入之前它们连不上云端。',
      identityReplaced:
        '{count} 把曾注册到 Chirp 的旧公钥被替换后没有吊销。云端可能仍持有这些旧公钥，对应的 CCU 用新公钥连不上。',
      identityStuck: '{count} 条注册被领取后一直没有结果。这个数字长时间不动，说明处理进程中途停了。',
      identityDuplicate: '{count} 次检测因为身份值已被另一个模块占用而被判不合格。两个模块里必有一个认错了。'
    },
    serverBuild: '服务端版本',
    serverTime: '服务端时间（UTC）'
  },
  placeholder: {
    title: '这个页面还没有后端支撑。',
    willContain: '将会包含'
  },
  scanCode: {
    alt: '{value} 的可扫描图形',
    empty: '没有可编码的内容',
    cannotRender: '这个值无法生成条形码',
    dialogHint: '用扫码枪对准屏幕，或读取每个图形下面的字符。',
    noCodes: '这一行没有可扫描的码。',
    show: '查看码'
  },
  ops: {
    command: {
      title: '车辆指令',
      description:
        '操作员在工位上给车辆下过的每一条指令：开锁、闭锁、打开电池锁、查询固件版本。车自己不留任何这边能读的账，所以这份记录是"这台车是谁开的锁"唯一的答案。无论结果如何都在列表里，包括根本没发出去的那些。「已发出，未确认」的意思是没有任何东西回报车做了这件事 —— 它不等于车拒绝了，也不是可以据此把车送去返修的故障。',
      search: '查询',
      retry: '重试',
      loadFailed: '指令记录加载失败。',
      empty: '没有匹配的指令。',
      imei: '模块',
      imeiPlaceholder: 'IMEI 前缀',
      frameNumberPlaceholder: '车架号前缀',
      plateNumberPlaceholder: '车牌',
      vehicle: '车辆',
      notBoundYet: '尚未绑定',
      operator: '操作人',
      sentAt: '发出时间',
      confirmedAt: '确认时间',
      commandColumn: '指令',
      outcomeColumn: '结果',
      transportColumn: '经由',
      subject: '主题',
      commandId: '指令 ID',
      said: '车辆回报了什么',
      saidNothing: '观察窗口内车辆一声没吭。',
      still: 'AI 盒子图片',
      stillFailed: '图片加载失败。',
      stillTaken: '来自 {time} 发出的这条指令。如果和现场不符，可能是盒子保留了更早的一张图。',
      errorDetail: '传输层报的内容',
      filterAnyCommand: '全部指令',
      filterAnyOutcome: '全部结果',
      filterAnyTransport: '全部经由',
      command: {
        UNLOCK: '开锁',
        LOCK: '闭锁',
        BATTERY_SWAP: '打开电池锁',
        READ_FIRMWARE: '查询固件版本',
        OPS_ENTER: '进入运维模式',
        OPS_EXIT: '退出运维模式',
        REBOOT: '重启 CCU',
        RING: '响铃',
        FOTA: '开始 OTA 升级',
        FOTA_CANCEL: '取消 OTA 升级',
        OPS_ECU_POWER_ON: 'ECU 上电',
        OPS_ECU_POWER_OFF: 'ECU 下电',
        OPS_ECU_LOCK: 'ECU 锁定',
        OPS_ECU_UNLOCK: 'ECU 解锁',
        OPS_ECU_HEADLIGHT_ON: '大灯开',
        OPS_ECU_HEADLIGHT_OFF: '大灯关',
        OPS_ECU_UPGRADE: 'ECU 升级',
        OPS_CAN_SEND: '发送 CAN 帧',
        OPS_AUDIO_TEST_SOUND: '播放测试音',
        OPS_BTL_LOCK: '电池锁上锁',
        OPS_BTL_UNLOCK: '电池锁开锁',
        OPS_HUBLOCK_LOCK: '轮毂锁上锁',
        OPS_HUBLOCK_UNLOCK: '轮毂锁开锁',
        WIFI_PROVISION: '添加 WiFi',
        WIFI_FORGET: '删除 WiFi',
        OPS_VPU_CAPTURE_IMAGE: 'AI 盒子抓图并显示图片',
        VPU_CAPTURE_IMAGE: 'AI 盒子抓图',
        VPU_DIAGNOSTIC: 'AI 盒子诊断'
      },
      group: {
        TRIP: '行程',
        OPS_MODE: '运维模式',
        ECU: 'ECU',
        BATTERY_LOCK: '电池锁',
        HUB_LOCK: '轮毂锁',
        SYSTEM: 'CCU',
        FIRMWARE: '固件',
        NETWORK: '网络',
        AI_BOX: 'AI 盒子'
      },
      argument: {
        operatorToken: '操作员令牌',
        taskToken: '任务令牌',
        delaySeconds: '延迟（秒）',
        pattern: '模式',
        durationMs: '时长（毫秒）',
        imageUrl: '镜像地址',
        sha256: 'SHA-256',
        targetCommandId: '要取消的指令 ID',
        path: 'CCU 上的路径',
        canId: 'CAN ID（十六进制）',
        data: '数据（十六进制）',
        extended: '扩展帧',
        sound: '音频文件',
        volumePct: '音量 %',
        ssid: 'SSID',
        passphrase: '密码',
        operation: '操作'
      },
      outcome: {
        CONFIRMED: '完成',
        NOT_CONFIRMED: '已发出，未确认',
        PUBLISHED: '已发出（无回执）',
        INFRA_ERROR: '没有发出'
      },
      transport: {
        CLOUD_CHIRP: '经网络',
        STATION_LOCAL_BUS: '工位数据线'
      },
      failure: {
        TRANSPORT_UNAVAILABLE: '连不上车辆',
        RATE_LIMITED: '因流量被拒'
      }
    },
    state: {
      group: {
        MODE: '整车模式',
        CCU: 'CCU',
        ECU: 'ECU',
        BMS: '电池 BMS',
        BATTERY_LOCK: '电池锁',
        HUB_LOCK: '轮毂锁',
        DISPLAY: '显示屏',
        QI_CHARGER: '无线充',
        NETWORK: '网络',
        GPS: 'GPS',
        AI_BOX: 'AI 盒子',
        AUDIO: '音频',
        SENSOR: '惯性传感器'
      }
    }
  },
  provision: {
    records: {
      title: 'CCU5 烧录记录',
      description:
        '烧录工位每做一次，这里就是一行：一块空板写入了哪个固件，生产密钥哈希有没有烧进去并锁上。两步都不可逆，板子锁上之后连读都读不了，所以这一行是这块板发生过什么的唯一凭据——失败的那次和成功的那次一样要留。烧写密钥是另一个需要人主动确认的动作，所以只刷机、没烧写是正常情况，不是缺陷。',
      search: '搜索',
      batchPlaceholder: '批次号前缀',
      machinePlaceholder: '硬件版本',
      operatorPlaceholder: '操作员',
      filterAnyFlash: '全部刷机结果',
      filterAnyClose: '全部关闭结果',
      filterAnyFuse: '全部烧写结果',
      batch: '批次',
      machine: '硬件版本',
      firmware: '固件',
      flashColumn: '刷机',
      closeColumn: '关闭',
      fuseColumn: '烧写',
      failureColumn: '失败原因',
      locked: '已锁定',
      notLocked: '未锁定',
      where: '工厂和操作员',
      startedAt: '开始时间',
      finishedAt: '结束时间',
      unfinished: '中途放弃',
      recordedAt: '入库时间',
      whatWasWritten: '写入了什么，读回了什么',
      bundleName: '固件包',
      noBundleName: '未上报',
      programmerVersion: '烧录器版本',
      firmwareDigest: '固件包摘要',
      noDigest: '未计算',
      otpReadBack: '读回的密钥哈希',
      otpNeverRead: '未读取',
      boardIdentifier: '板子标识',
      noBoardIdentifier: '这块板没有任何可用标识',
      toolVersion: '工具版本',
      attemptRef: '本次编号',
      noAttemptRef: '未上报',
      failuresOnThisPage: '本页有 {count} 次失败',
      empty: '还没有烧录记录。烧录工位工作时会自动产生。',
      loadFailed: '烧录记录加载失败。',
      retry: '重试',
      flash: {
        OK: '已写入',
        FAILED: '失败',
        NOT_ATTEMPTED: '未执行'
      },
      close: {
        OK: '已关闭',
        FAILED: '失败',
        REFUSED: '已拒绝',
        NOT_ATTEMPTED: '未执行'
      },
      fuse: {
        OK: '已烧写',
        FAILED: '失败',
        REFUSED: '已拒绝',
        NOT_ATTEMPTED: '未执行'
      }
    }
  },
  ccuEol: {
    checkItems: {
      title: 'CCU 检测项',
      description: '本服务能对 CCU 模块执行的全部检测。批次的验收标准从这个列表里挑选,并为每一项设定规则。',
      itemSetManagedByMigration: '检测项清单不在此处编辑。一个检测项之所以存在,是因为代码知道如何从模块读取它,所以新增项随对应代码一起以 migration 提交。本页面设定的是通道。',
      code: '编码',
      name: '名称',
      channel: '通道',
      reads: '读取内容',
      state: '状态',
      enabled: '启用',
      disabled: '停用',
      noDescription: '暂无说明',
      channelNotEstablished: '尚未确定',
      channelPlaceholder: '例如 CAN',
      editChannelMap: '设定通道',
      saveChannelMap: '保存通道',
      cancel: '取消',
      channelMapSaved: '通道已保存。',
      groupsLabel: '可同时读取:',
      groupCount: '{count} 项',
      groupsHint:
        '同一通道上的检测项逐项读取,不同通道之间可以同时读取。通道尚未确定的检测项一律逐项读取,所以填上一个只会缩短节拍。',
      empty: '没有检测项。请对该数据库执行 migration。',
      loadFailed: '检测项加载失败。',
      retry: '重试',
      count: '共 {count} 项'
    },
    acceptanceRecords: {
      title: 'CCU EOL 验收记录',
      description:
        'CCU 验收工位的每一次尝试一行。重测是独立的一行，之前那次照样保留，所以一台先失败、重测通过的模块会出现两次——首次通过率只算第一次尝试。展开一行可以看到每个检测项、模块当时上报的原始值，以及当时判定它的那条规则。',
      search: '搜索',
      filterAnyBatch: '全部批次',
      filterAnyStage: '全部环节',
      filterAnyVerdict: '全部判定',
      imeiPlaceholder: 'IMEI 前缀',
      firstAttemptOnly: '只看首次尝试',
      imei: 'IMEI',
      batch: '批次',
      batchMissing: '批次已不存在',
      stageColumn: '环节',
      attemptNo: '第几次',
      verdictColumn: '判定',
      failedItems: '{count} 项不合格',
      released: '已放行',
      releasedYes: '已放行',
      releasedNo: '未放行',
      where: '地点与操作员',
      startedAt: '开始时间',
      finishedAt: '结束时间',
      unfinished: '未结束',
      toolVersion: '工具版本',
      collected: '本次从模块读到的信息',
      iccid: 'SIM ICCID',
      bluetoothName: '蓝牙广播名',
      bluetoothMac: '蓝牙 MAC',
      wifiMac: 'WiFi MAC',
      publicKey: '云身份公钥',
      checks: '检测项',
      item: '检测项',
      rawValue: '上报值',
      noValue: '未取到值',
      judgedAgainst: '当时的判定规则',
      execution: '读取',
      itemVerdict: '判定',
      attempts: '该模块在本环节的全部尝试 —— 共 {count} 次',
      detailLoading: '加载中…',
      detailFailed: '这次尝试的详情加载失败。',
      firstAttemptFailures: '本页有 {count} 次首测未通过',
      empty: '还没有验收记录。工位工具上报测试结果后，这里就会有数据。',
      loadFailed: '加载验收记录失败。',
      retry: '重试',
      stage: {
        OUTGOING: '出厂',
        INCOMING: '入厂'
      },
      verdict: {
        PASS: '通过',
        FAIL: '不合格',
        INFRA_ERROR: '基础设施异常'
      },
      execution_: {
        OK: '正常',
        TIMEOUT: '超时',
        ERROR: '出错',
        SKIPPED: '跳过'
      },
      itemVerdict_: {
        PASS: '合格',
        FAIL: '不合格',
        NOT_JUDGED: '仅记录'
      },
      rule: {
        exact: '要求等于 {value}',
        regex: '要求匹配 {pattern}',
        range: '要求在 {min} 到 {max} 之间',
        none: '只记录，不判定'
      }
    },
    identity: {
      title: 'CCU 身份',
      description:
        '在唯一采集点采集到的 CCU 模块身份：IMEI、SIM ICCID、蓝牙 MAC 与广播名、WiFi MAC，以及云身份公钥。这些都属于 CCU 模块本身，不是整车。出厂后没有系统性的机会再采一次。',
      search: '搜索',
      imeiPlaceholder: 'IMEI 前缀',
      iccidPlaceholder: 'ICCID 前缀',
      filterAnyStatus: '全部状态',
      status: {
        PENDING: '待注册',
        IN_PROGRESS: '注册中',
        REGISTERED: '已注册',
        FAILED: '注册失败'
      },
      imei: 'IMEI',
      iccid: 'SIM ICCID',
      statusColumn: '云端注册',
      attemptCount: '已尝试 {count} 次',
      where: '采集地点',
      collectedAt: '采集时间',
      registeredAt: '注册时间',
      notRegistered: '尚未注册',
      unregistered: '当前列出的模块中有 {count} 台还连不上云端',
      empty: '还没有身份记录。模块通过出厂检或入厂检后才会生成一条。',
      loadFailed: '身份列表加载失败。',
      retry: '重试',
      detailLoading: '加载中…',
      detailFailed: '这条身份记录加载失败。',
      collected: '本次检测读到的内容',
      bluetoothName: '蓝牙广播名',
      bluetoothMac: '蓝牙 MAC',
      wifiMac: 'WiFi MAC',
      stage: '工位',
      stage_: {
        OUTGOING: '出厂检（CCU 工厂）',
        INCOMING: '入厂检（整车厂）'
      },
      operator: '操作员',
      publicKey: '云身份公钥',
      registration: '注册进展',
      attempts: '已用尝试次数',
      nextAttemptAt: '下次尝试',
      remoteRef: '注册表引用',
      lastError: '最近一次失败',
      keyHistory: '被替换的公钥（{count}）',
      replacedKey: '被替换的公钥',
      reachedState: '替换前',
      replacedKeyState: {
        never: '从未注册',
        registered: '曾注册',
        revoked: '已吊销'
      },
      revokedBy: '{name} 于 {at}（UTC）吊销',
      revokedAt: '不晚于 {at}（UTC）吊销',
      supersededAt: '替换时间',
      registryStale:
        '这台 CCU 的旧公钥曾注册到 Chirp，之后公钥变了。云端可能仍持有旧公钥，CCU 用新公钥连不上。请点击“注册到 Chirp”，确认后吊销旧公钥并注册新公钥。',
      register: '注册到 Chirp',
      registerHint: '注册后车辆才能连上 Chirp，并从此刻起进入唯一一次工厂窗口。',
      registered: '已注册到 Chirp。',
      replaceTitle: '吊销旧公钥',
      replaceConfirm: 'Chirp 中这个 IMEI 仍登记着这个 CCU 之前的公钥。注册新公钥需要先在 Chirp 吊销旧公钥，吊销是永久的：旧公钥以后不能再在任何 IMEI 下注册。确定继续？',
      replaceConfirmButton: '吊销并注册',
      cancel: '取消'
    },
    device: {
      title: '已验收 CCU 模块',
      description:
        '每个通过来料检的模块一行，以及运维平台是否已经知道它。这里的值是外部系统认识它的那些编号——IMEI、SIM ICCID、蓝牙、WiFi——取模块验收当时的状态，也就是实际发出去的内容，而不是最近一次检测读到的。市场、厂商、通信模块三列在映射规则确定前留空。',
      search: '搜索',
      imeiPlaceholder: 'IMEI 前缀',
      iccidPlaceholder: 'ICCID 前缀',
      filterAnyStatus: '全部状态',
      filterAnySource: '全部来源',
      status: {
        PENDING: '等待发送',
        IN_PROGRESS: '发送中',
        SYNCED: '已发送',
        FAILED: '发送失败',
        WITHHELD: '暂不发送'
      },
      sourceColumn: '来源',
      source: {
        INSPECTION: '来料检通过',
        MANUAL_ADMISSION: '人工准入'
      },
      imei: 'IMEI',
      iccid: 'SIM ICCID',
      bluetooth: '蓝牙',
      wifiMac: 'WiFi MAC',
      marketplace: '市场',
      manufacturer: '厂商',
      statusColumn: '车队注册',
      attemptCount: '已尝试 {count} 次',
      where: '验收地点',
      acceptedAt: '验收时间',
      syncedAt: '发送时间',
      notSynced: '尚未发送',
      unsynced: '当前列出的模块中有 {count} 个还没进入车队',
      withheldCount: '{count} 个在检验前暂不发送',
      empty: '暂无模块。模块通过来料检后会出现在这里。',
      loadFailed: '模块列表加载失败。',
      retry: '重试',
      actions: '操作',
      codesTitle: '模块 {imei}',
      command: {
        open: '指令',
        title: '给模块 {imei} 下发指令',
        warningTitle: '指令会真的发到这个模块',
        warningBody:
          '每个按钮都会把指令直接发给该模块；如果这个模块已经装到车上，车会真的动起来。按之前请先确认下面这台车就是你要操作的那台。',
        target: '会作用在',
        resolving: '正在查询…',
        notBoundYet: '只有模块本身 —— 还没有装到任何车上',
        resolveFailed: '查不到这个模块会作用在什么上面。',
        sendFailed: '指令没有发出去。',
        tabCommands: '指令',
        tabState: '读状态',
        opsHint: '需要运维模式，请先发送“进入运维模式”。',
        send: '发送',
        cancel: '取消',
        confirmTitle: '确认发送“{command}”？',
        confirmBody: '这会改变模块的运行状态，请先确认上面的目标。',
        stateHint: '让模块重新上报状态。不会改变状态，但读 ECU 会给 ECU 上电。',
        answered: '已回复',
        partial: '部分回复',
        noAnswer: '无回复',
        readFailed: '状态读取失败。'
      },
      admit: {
        open: '从清单准入',
        title: '从清单准入模块',
        warningTitle: '这些模块不会被检验',
        warningBody:
          '清单中的每个模块都将在未经检测的情况下可用于装车，并在有人检验它之前暂不进入车队。这里不会记录任何测试结果。',
        fileLabel: 'IMEI 清单',
        choose: '选择文件',
        fileTip:
          '支持 .xlsx 或 .csv。任何 15 位数字的单元格都会被识别为 IMEI，因此列顺序和表头可以是任意的。如果某一列显示为 8.7E+14 之类，请把该列设为文本后重新导出——那些数字已经丢失了。',
        reasonLabel: '为何可以免检验装车',
        reasonPlaceholder: '例如：这批属于哪个项目，以及目前还缺什么',
        submit: '确认准入',
        close: '关闭',
        imported: '已准入',
        alreadyAccepted: '已检验过',
        duplicate: '已准入过',
        skipped: '无 IMEI 的行',
        rejected: '{count} 个单元格像 IMEI 但不是'
      },
      manual: {
        open: '手动添加',
        title: '手动添加模组',
        imeiLabel: 'IMEI',
        imeiPlaceholder: '一行一个',
        imeiTip:
          '每个 15 位数字 —— 和导入列表的规则一致。一行一个，也可以用逗号或空格分隔。不是 IMEI 的内容会原样列出来，而不是跳过，这样打错的模组不会被悄悄丢掉。',
        counted: '待添加 {valid} 个，重复 {repeated} 个',
        invalid: '{count} 项不是 IMEI',
        tooMany: '超出了手动添加的数量上限，请改用导入列表。',
        submit: '添加'
      }
    },
    standards: {
      title: 'CCU EOL 验收标准',
      description:
        '按生产批次定义 CCU 出厂"什么状态算合格"：查哪些项，每一项按什么规则判定。标准属于批次本身，批次之间不共用。限值可以直接修改，从下一次测试开始生效——已经记录下来的每条结果都带着当时判定它的那条规则。',
      new: '新建批次',
      search: '搜索',
      searchPlaceholder: '搜索批次码或说明',
      filterAll: '全部状态',
      filterAnyItem: '全部检测项',
      enabled: '已启用',
      disabled: '已禁用',
      batchCode: '批次码',
      batchDescription: '说明',
      noDescription: '暂无说明',
      itemCount: '检测项',
      itemCountValue: '{count} 项',
      state: '状态',
      lastEdited: '最后修改',
      actions: '操作',
      edit: '编辑',
      enable: '启用',
      disable: '禁用',
      empty: '还没有批次。新建一个，工位才有可以对照的标准。',
      loadFailed: '加载批次失败。',
      retry: '重试',
      createTitle: '新建批次',
      editTitle: '编辑批次',
      save: '保存',
      cancel: '取消',
      batchCodePlaceholder: '20260825-A',
      batchCodeHint: '工位工具按这个码拉取配置。在第一台模块被测之前还可以更正。',
      batchCodeLockedHint:
        '已锁定：已有 {count} 条验收记录挂在这个批次上，工位工具正是按这个码拉取配置的。如需更换，请新建批次——可以把当前标准复制过去。',
      batchDescriptionPlaceholder: 'CCU5，首批量产',
      items: '验收标准',
      itemsHint:
        '这里列出本服务能对 CCU 执行的全部检测项。本批次不检的项，把"检测"取消即可——当前勾选 {count} 项。表格顺序就是工位上的显示和执行顺序，可以用箭头调整。',
      item: '检测项',
      itemWithdrawn: '已停用',
      noItemDescription: '目录里还没有这一项的说明。',
      ruleType: '规则类型',
      ruleValue: '规则值',
      example: '示例',
      checked: '检测',
      min: '下限',
      max: '上限',
      valuePlaceholder: '需要完全相等的文本',
      patternPlaceholder: '正则表达式',
      noValueNeeded: '无需填写',
      catalogueUnavailable: '检测项目录加载失败，暂时无法配置标准。',
      ruleTypeName: {
        EXACT: '等于',
        REGEX: '正则匹配',
        RANGE: '区间',
        NONE: '只记录'
      },
      importFrom: '从已有批次导入',
      import: '导入',
      imported: '已从 {code} 导入 {count} 条规则。',
      checkAll: '全选',
      uncheckAll: '全不选',
      catalogueOrder: '恢复默认顺序',
      order: '顺序',
      moveUp: '上移',
      moveDown: '下移',
      issueCount: '有 {count} 项还没填好',
      judgesNothing:
        '所有勾选项都是"只记录"，也就是这个批次不判定任何东西，会放行每一台模块。作为收集数据的试产批次是合理的——只是要知道保存的就是这个。',
      itemRule: {
        natsLeaf: '这个批次的模块应当连接的地址；工位只读取比对，不会改写模块。选择“等于”，填 nats-leaf://主机:端口，不带路径、用户名，端口后面不加任何内容。',
        natsUplink: '选择“等于”并填 connected，或选择“只记录”。本批次必须同时勾选 nats.leaf；如果 hub 还不接受该模块，每个模块都会失败。',
        ccuPoweroff: '选择“等于”并填 off，或选择“只记录”。工位最后执行，只有其他项全部通过才会关机。',
        ccuProvision: '按这个批次的运行配置填：“烧写密钥并关闭”→ 等于 CLOSED；“只烧写密钥”→ 等于 LOCKED；“不在本工位烧写”→ 不加这一项或选“只记录”，如果板子必须保持未烧写则等于 OPEN。FUSED（烧了但没锁）是缺陷，任何时候都不能作为合格值。需要 ZestOS ccu5-v0.4.0 及以上。',
        ccuOs: '这个批次应出货的 ZestOS 版本。选择“等于”，按模块上报的写法填，带 v：填 v0.4.2，不是 0.4.2。',
        lteFw: '产线升级后 4G 模组应有的固件版本。选择“等于”，填完整版本号，包括下划线后面的部分，例如 EG916QGLLGR01A05M04_A0.305.A0.305。“等于”只填前半段，每台 CCU 都会不合格；用正则只匹配前半段，没升级的 CCU 也会合格。'
      },
      issue: {
        valueRequired: '需要填写要求相等的文本。',
        patternRequired: '需要填写正则表达式。',
        patternInvalid: '正则表达式不合法。',
        boundsRequired: '需要填写下限和上限。',
        boundsNotNumeric: '上下限必须是数字。',
        boundsInverted: '下限大于上限。',
        leafUrlInvalid: '必须选择“等于”，值的格式为 nats-leaf://主机:端口。',
        uplinkNeedsLeaf: '必须同时勾选 nats.leaf 才能检测。'
      },
      batchCodeRequired: '请填写批次码。',
      itemsRequired: '批次至少要检测一项。一个什么都不检的批次会放行每一台模块。',
      fixIssuesFirst: '有几项还没填好，请先修正再保存。',
      saved: '已保存。',
      disableConfirmTitle: '禁用批次',
      disableConfirm: '确定禁用 {code}？工位将直接拒测该批次而不会退化成别的标准，已产生的记录全部保留。',
      enabledDone: '批次已启用。',
      disabledDone: '批次已禁用。',
      appliesFromNextTest: '从下一次测试开始生效。',
      pastRecordsKeepTheirRule: '已经记录的 {count} 次尝试仍保留当时判定它们的规则。',
      lastEditedBy: '上次由 {who} 于 {when} 修改。',
      settings: '运行配置',
      settingsHint: '工位怎么处理这个批次，而不是怎样算合格。和批次一起保存；没有改动的配置不会被写入。',
      settingDefault: '默认',
      settingsNotLoaded: '运行配置还没加载完，暂不保存。请稍等，或者重新打开这个批次。',
      settingValue: {
        'provision.mode': {
          NONE: '不在本工位烧写',
          FUSE: '只烧写密钥',
          FUSE_AND_CLOSE: '烧写密钥并关闭'
        }
      },
      closeConfirmTitle: '关闭这个批次的板子',
      closeConfirm:
        '从现在起，烧写工位在 {code} 里烧写的每一块板子都会同时关闭。关闭无法撤销：关闭后的板子不能再通过 USB 读取或烧写。确定保存？',
      closeConfirmOk: '关闭这个批次的板子'
    }
  },
  vehicleEol: {
    checkItems: {
      title: '整车检测项',
      subtitle: '一台整车可以检测哪些项。',
      note: '只读。项目代码是工位工具和 App 上报时用的标识，所以这份清单随版本发布，不在这里创建。某个 SKU 按哪些项、按什么限值判定，属于验收标准。',
      code: '检测项',
      name: '名称',
      component: '组件',
      wholeVehicle: '整车',
      testType: '测试类型',
      description: '读取什么',
      state: '状态',
      inUse: '在用',
      withdrawn: '已停用',
      anyCollectedBy: '车辆读取或人工操作',
      collectedBy: '数据来源',
      operatorCount: '{count} 项需人工',
      anyTestType: '全部类型',
      anyComponent: '全部组件',
      empty: '没有匹配的检测项。',
      loadFailed: '检测项列表加载失败。',
      operatorInstruction: '操作指示（源文本）',
      instructionMissing: '缺指示',
      instructionNotNeeded: '无需',
      missingInstructionCount: '{count} 项人工检测没有操作指示',
      instructionNote: '工位 App 按项目代码用操作员自己的语言显示这些话 —— 这里是它们所依据的英文原文，也是 App 没有该代码字符串时的回退。改操作员看到的文案要发工位版本。这一页上要紧的是某项检查到底有没有指示：没有，App 就不显示动作那一步。'
    },
    testType: {
      STATIC: '静态检测',
      RIDE: '骑行测试'
    },
    collectedBy: {
      VEHICLE: '由服务读车',
      OPERATOR: '需人工操作'
    },
    binding: {
      title: '车辆绑定',
      description:
        '哪台车装的是哪个 CCU、车牌是哪个、VIN 是哪个，以及同步到 ops 平台的进度。正常情况下绑定和解绑都在工位上对着实车完成；这里的绑定用于车辆离开工位之后的纠正。',
      keywordPlaceholder: '车架号、车牌、IMEI 或 VIN',
      filterAnyState: '全部（含已解绑）',
      filterAnyStatus: '全部同步状态',
      search: '搜索',
      frameNumber: '车架号',
      plateNumber: '车牌',
      imei: 'CCU IMEI',
      vinCode: 'VIN',
      noVin: '该车型不带',
      qrCode: '车辆二维码',
      scanTitle: '{label} · {frame}',
      scanCue: '点击任一编码，可放大成扫码枪能读的符号。',
      qrHint: '二维码里是车上那个码实际编码的网址，不是车牌号。',
      releasedAt: '已解绑',
      opsBikeId: 'Ops 车辆 ID',
      sku: 'SKU',
      opsStatusColumn: '车辆同步',
      vinStatusColumn: 'VIN 同步',
      where: '绑定工厂',
      boundAt: '绑定时间',
      attemptCount: '已尝试 {count} 次',
      unsynced: '本页有 {count} 条尚未推送',
      empty: '没有匹配的绑定记录。',
      loadFailed: '绑定记录加载失败。',
      retry: '重试',
      actions: '操作',
      cancel: '取消',
      bind: {
        open: '绑定车辆',
        title: '绑定车辆',
        notice: '这里写入的就是工位写入的那条记录，校验也完全一样。用于纠正已经离开工位的车，不是替工位干活。',
        optionsFailed: '工厂和 SKU 列表加载失败。',
        factory: '工厂',
        factoryHint: '这台车在哪装的。车架号里的工厂位会拿它来校验，选错的结果是编码被拒，而不是记到错的工厂名下。',
        sku: 'SKU',
        qrCode: '车辆二维码',
        qrHint: '填车牌上那个码实际编码的网址，不是印着的六位字符。',
        resolvedPlate: '这个码对应车牌 {plate}，请和实车核对。',
        vinHint: '该 SKU 带 VIN，必须填。',
        checking: '校验中…',
        submit: '绑定',
        confirmTitle: '确认绑定这台车？',
        confirmBody: '车架 {frame}，车牌 {plate}，CCU {imei}，工厂 {factory}。绑定后会通知 ops 平台。',
        done: '已绑定 {frame}。',
        failed: '没有完成绑定。'
      },
      release: {
        open: '解绑',
        title: '确认解绑？',
        body: '车架 {frame} 及其车牌、CCU、VIN 都会释放出来供别的车占用，并通知 ops 平台该车已移除。记录会保留。',
        reason: '原因',
        reasonHint: '这是这台车为什么返工的唯一记录，几个月后会有人来看。',
        submit: '解绑',
        done: '已解绑 {frame}。',
        failed: '没有完成解绑。'
      },
      state: {
        LIVE: '生效中',
        RELEASED: '已解绑'
      },
      operation: {
        UNBIND: '待移除'
      },
      status: {
        PENDING: '待推送',
        IN_PROGRESS: '推送中',
        SYNCED: '已推送',
        FAILED: '推送失败',
        CANCELLED: '已取消'
      }
    },
    acceptanceRecords: {
      title: 'Vehicle EOL 验收记录',
      description:
        '一行是一台车在两类检测中某一类的一次尝试。两类各自独立编号，因此静态检测重测不会影响骑行测试的记录，一次通过率也能分别计算。展开可以看到每一项检测、上报的值，以及当时判定它的规则。',
      search: '查询',
      framePlaceholder: '车架号前缀',
      imeiPlaceholder: 'IMEI 前缀',
      filterAnyTestType: '全部检测类型',
      filterAnyResult: '全部结果',
      filterAnySku: '全部 SKU',
      firstAttemptOnly: '只看首次尝试',
      frameNumber: '车辆',
      sku: 'SKU',
      testTypeColumn: '检测',
      attemptNo: '尝试',
      resultColumn: '结果',
      failedItems: '{count} 项不合格',
      standard: '判定标准',
      standardMissing: '标准已不存在',
      version: '第 {version} 版',
      where: '地点与操作人',
      startedAt: '开始时间',
      finishedAt: '结束时间',
      unfinished: '未结束',
      context: '本次检测是怎么跑的',
      scanned: '扫描内容',
      communicationPath: '通信方式',
      toolVersion: '版本',
      failureCode: '失败码',
      checks: '检测项',
      item: '检测项',
      component: '组件',
      wholeVehicle: '整车',
      rawValue: '上报值',
      noValue: '未取到值',
      judgedAgainst: '判定规则',
      execution: '读取',
      itemVerdict: '判定',
      byOperator: '人工确认',
      checkTheVehicle: '操作员操作了，但车辆没有反应。在安排返修之前，请先确认扫到的车就是眼前这台。',
      attempts: '该车该检测共 {count} 次尝试',
      detailLoading: '加载中…',
      detailFailed: '该次尝试加载失败。',
      empty: '没有匹配的记录。',
      loadFailed: '验收记录加载失败。',
      retry: '重试',
      firstAttemptFailures: '当前显示的记录中有 {count} 条是首次尝试未通过',
      testType: {
        STATIC: '静态检测',
        RIDE: '骑行测试'
      },
      result: {
        PASS: '通过',
        FAIL: '不通过',
        ABORTED: '已取消',
        INFRA_ERROR: '环境问题'
      },
      execution_: {
        OK: '已读取',
        TIMEOUT: '超时',
        ERROR: '错误',
        SKIPPED: '未执行'
      },
      itemVerdict_: {
        PASS: '通过',
        FAIL: '不通过',
        NOT_JUDGED: '仅记录'
      },
      rule: {
        exact: '必须等于 {value}',
        regex: '必须匹配 {pattern}',
        versionList: '必须是 {versions} 之一',
        range: '{min} 到 {max}',
        atLeast: '不小于 {min}',
        atMost: '不大于 {max}',
        present: '必须有应答',
        none: '仅记录不判定'
      },
      exchanges: '报文',
      viewExchanges: '{count} 条 · 查看',
      exchangesTitle: '{item} 与车辆的往来',
      exchangesHint: '服务端自己记录的传输过程，按发生顺序：先是让这项检查可作答的指令（如果需要），然后是读取。这是证据不是判定 —— 某个 subject 没到是部件的事实，发布被拒是网络的事实。',
      sent: '发送',
      received: '收到',
      nothingSent: '没有发送任何报文。'
    },
    standards: {
      title: '整车验收标准',
      subtitle: '什么样的整车算合格 —— 一次一个版本。',
      create: '新建标准',
      createTitle: '新建验收标准',
      editTitle: '编辑 {label}',
      supersedeTitle: '基于 {label} 新建版本',
      frozenNote: '{label} 已经判定过车辆，不能再修改。保存会创建下一个版本；按这一版判定的 SKU 会继续用它，直到有人重新选择。',
      code: '标准',
      codePlaceholder: '例如 SCOOTER_GEN5_EU',
      codeHint: '编码就是这个标准本身：在它下面保存的每一版都沿用同一个编码，版本号顺次加一。SKU 是按某一个版本判定的，所以编码定一次就一直用。',
      description: '说明',
      descriptionHint: '这一版要求什么，或者与上一版的差别。为 SKU 选择标准时看到的就是这一行，所以写给做选择的人看。',
      state: '状态',
      frozen: '已定',
      draft: '可修改',
      frozenAt: '首次使用',
      itemCount: '检测项',
      skuCount: 'SKU 数',
      actions: '操作',
      edit: '编辑',
      supersede: '新建版本',
      checks: '检测项',
      checkedCount: '已选 {count} 项',
      checksHint: '勾选这一版要求的检测项，再说明每项怎么判。NONE 表示只记录不判定，是安全的默认值 —— 一个没人选过的限值比没有限值更糟。',
      check: '检测项',
      testType: '测试类型',
      ruleType: '判定方式',
      rule: '规则',
      withdrawn: '已停用',
      noParameters: '无参数',
      valuePlaceholder: '必须等于',
      patternPlaceholder: '正则表达式',
      min: '不小于',
      max: '不大于',
      versionsPlaceholder: '例如 3.8.1，回车添加',
      confirm: '需人工确认',
      codeRequired: '请填写标准编码。',
      cancel: '取消',
      saveDraft: '保存修改',
      saveAsNewVersion: '创建版本',
      savedDraft: '修改已保存。',
      savedNewVersion: '{label} 已创建。',
      empty: '还没有任何标准。',
      loadFailed: '标准列表加载失败。',
      collectedBy: '数据来源',
      collectedByHint: '人工采集的项由手持机提示操作员；车辆采集的项由服务读取。这由数据来源决定，不在这里设置。',
      operatorPresentWarning: '这一项由操作员作答，而「有应答即可」看的是状态、不是答案 —— 操作员点“没有正常”也会判为合格。请改用「完全相等」，值填 true。',
      delete: '删除',
      deleteConfirmTitle: '确认删除这条标准？',
      deleteConfirm: '{label} 和它的检查项都会被删掉。没有车在它下面判过，所以没有记录需要保留 —— 但如果有 SKU 选用了它，要先把那些 SKU 指到别处。',
      deleted: '标准已删除。',
      codeLockedHint: '后面的版本不能改名：v1、v2 会留在旧代码下，只有这一版跟着走。只有第一版的代码还能纠正。'
    },
    exchangeOutcome: {
      'answered': '已应答',
      'no answer in the window': '窗口内无应答',
      'NOT_SUPPORTED': '无人发布此值',
      'RATE_LIMITED': '因流量被拒',
      'CCU_SILENT': 'CCU 未应答，未询问',
      'CCU_VERSION_UNREAD': 'CCU 未报告固件版本，未询问',
      'VENDOR_UNKNOWN': 'ECU 厂商未知',
      'EPOCH_CHANGED': '里程计数中途重置',
      'RESOLUTION_TOO_COARSE': '里程计数精度不足',
      'TRANSPORT_UNAVAILABLE': '无法连接车辆'
    },
    ruleTypeHint: {
      NONE: '只记录，不判定。适合先把值收集起来、限值还没定的情况。',
      PRESENT: '部件有应答就算合格。用于通讯类检查：答不上来意味着少装件或线束夹伤。',
      EXACT: '值必须完全等于填的内容。人工项填 true。',
      REGEX: '值匹配这个正则就算合格。',
      RANGE: '数值落在区间内就算合格，只填一边也可以。',
      VERSION_LIST: '版本在列表里就算合格。列出批准的构建，不用区间。'
    },
    ruleType: {
      NONE: '仅记录',
      PRESENT: '有应答即可',
      EXACT: '精确值',
      REGEX: '正则匹配',
      RANGE: '数值范围',
      VERSION_LIST: '版本清单'
    }
  },
  admin: {
    organisations: {
      title: '工厂',
      description:
        '在这里验收单元的每一家工厂，以及 Lime 自身——Lime 没有车架码，因为那里不生产。不提供删除：禁用一家工厂会让其名下所有账号无法登录，同时保留记录可供审计。',
      searchPlaceholder: '搜索编码或名称',
      search: '搜索',
      filterAll: '全部状态',
      new: '新建工厂',
      edit: '编辑',
      enable: '启用',
      disable: '禁用',
      code: '编码',
      name: '名称',
      frameCode: '车架码',
      vinSiteCode: 'VIN Sit Code',
      latitude: '纬度',
      longitude: '经度',
      coordinates: '坐标',
      state: '状态',
      enabled: '已启用',
      disabled: '已禁用',
      actions: '操作',
      createTitle: '新建工厂',
      editTitle: '编辑工厂',
      save: '保存',
      cancel: '取消',
      codeRequired: '请填写编码。',
      nameRequired: '请填写名称。',
      disableConfirmTitle: '禁用工厂',
      disableConfirm: '确定禁用 {name}？在重新启用之前，其名下所有账号将无法登录。',
      saved: '已保存。',
      enabledDone: '工厂已启用。',
      disabledDone: '工厂已禁用。',
      empty: '暂无工厂，请先对该数据库执行迁移。',
      loadFailed: '加载工厂失败。',
      retry: '重试',
      count: '共 {count} 家工厂'
    },
    roles: {
      title: '角色',
      description:
        '决定一个账号能做什么。一个账号只持有一个角色，角色编码同时就是它所在的生产环节——CCU_OUTGOING_EOL、VEHICLE_DYNAMIC_EOL。角色不提供删除，编码也不可修改：所有账号都是按这个编码指向它的。',
      searchPlaceholder: '搜索编码或名称',
      search: '搜索',
      filterAnyPermission: '任意权限',
      new: '新建角色',
      exportRoleReview: '导出角色设计审查表',
      edit: '编辑',
      code: '编码',
      codePlaceholder: 'CCU_OUTGOING_EOL',
      codeHint: '仅大写字母、数字与下划线，创建后不可修改。',
      codeImmutableHint: '角色编码不可修改——持有该角色的账号都是按这个编码指向它的。如需更换，请新建角色并迁移账号。',
      name: '名称',
      permissions: '权限',
      allPermissions: '全部权限',
      noPermissions: '暂未授予任何权限',
      permissionsUnavailable: '权限列表加载失败，暂时无法编辑权限。',
      administratorLocked:
        'ADMINISTRATOR 拥有全部权限（含之后新增的），且不能在此处收窄——一旦被收窄，就再也没有人能进行任何管理操作，包括改回来。',
      renewalHint: '将在该账号下一次令牌续期时生效，最长一小时。',
      updatedAt: '更新时间',
      actions: '操作',
      createTitle: '新建角色',
      editTitle: '编辑角色',
      save: '保存',
      cancel: '取消',
      codeRequired: '请填写编码。',
      codeInvalid: '请使用大写字母、数字与下划线，并以字母开头。',
      nameRequired: '请填写名称。',
      saved: '已保存。',
      empty: '暂无角色，请先对该数据库执行迁移。',
      loadFailed: '加载角色失败。',
      retry: '重试'
    },
    operators: {
      title: '操作员',
      description:
        '登录人员的账号与角色。每一条判定都归属到其中一个账号，所以这里就是"谁放行了这台车"的审计依据。不提供删除——禁用即可阻止该账号以任何方式登录，同时保留其历史记录。',
      searchPlaceholder: '搜索用户名或邮箱',
      search: '搜索',
      filterAll: '全部状态',
      filterAllOrganisations: '全部工厂',
      filterAllRoles: '全部角色',
      new: '新建操作员',
      exportAccessReview: '导出用户访问审查表',
      import: '从文件导入',
      edit: '编辑',
      enable: '启用',
      disable: '禁用',
      username: '用户名',
      role: '角色',
      organisation: '所属工厂',
      email: '邮箱',
      signIn: '登录方式',
      signInPassword: '密码',
      signInGoogle: 'Google',
      signInNone: '未配置凭证',
      credentials: '登录方式',
      addCredential: '添加登录方式',
      credentialPassword: '密码登录',
      credentialGoogle: 'Google 登录',
      removeCredential: '移除',
      noCredentialWarning:
        '该账号将没有任何登录方式。这是允许的——账号可以先建好、登录方式后定——但在添加之前谁都无法使用它。',
      changePassword: '修改',
      keepPassword: '保持不变',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      passwordWillBeAdded: '保存时设置。',
      passwordWillBeReplaced: '保存时将替换已存储的密码。',
      passwordChangedAt: '已设置，上次修改于 {at}（UTC）。',
      passwordNeverChanged: '已设置，自建号以来从未修改。',
      passwordTooShort: '密码至少需要 {min} 个字符。',
      passwordMismatch: '两次输入的密码不一致。',
      googleEmail: 'Google 邮箱',
      googleEmailHint: 'Google 登录按该工作邮箱匹配。需在首次登录前填好。',
      googleEmailRequired: '请填写 Google 邮箱，或移除该登录方式。',
      googleLinked: '该账号已用 Google 登录过。',
      googleNotLinked: '已授权，但还没有人用 Google 登录过。',
      state: '状态',
      enabled: '已启用',
      disabled: '已禁用',
      actions: '操作',
      createTitle: '新建操作员',
      editTitle: '编辑操作员',
      save: '保存',
      cancel: '取消',
      usernameRequired: '请填写用户名。',
      roleRequired: '请选择角色。',
      organisationRequired: '请选择所属工厂。',
      disableConfirmTitle: '禁用操作员',
      disableConfirm: '确认禁用 {username}？重新启用前，该账号将无法通过任何方式登录。',
      saved: '已保存。',
      enabledDone: '已启用该操作员。',
      lockedUntil: '锁定至 {at}（UTC）',
      lockedHint: '连续多次密码错误，密码登录已暂停。到这个时间会自动解锁，也可以点“解锁”立即解除。',
      unlock: '解锁',
      unlockedDone: '已解锁密码登录。',
      disabledDone: '已禁用该操作员。',
      empty: '没有符合条件的操作员。',
      loadFailed: '加载操作员失败。',
      pickersFailed: '加载可选的角色与工厂失败。',
      retry: '重试',
      count: '共 {count} 个操作员',
      importTitle: '从文件导入操作员',
      importIntro:
        '两类账号，各用一份文件。先选类型再选文件，每一行都会先检查一遍——确认之前不会写入任何数据。',
      importFactory: '工厂账号',
      importFactoryHint: '工厂的账号，用密码登录，所属工厂由文件里每一行指定。',
      importInternal: '内部账号',
      importInternalHint: 'Lime 员工的账号，用工作邮箱通过 Google 登录。统一归在 Lime 名下，文件里不需要这一列。',
      importColumns: '列',
      importChooseFile: '选择文件',
      importTemplate: '下载模板',
      importFormatsFailed: '加载导入文件格式失败。',
      importReadFailed: '读取该文件失败。',
      importAnotherFile: '换一个文件',
      importStartOver: '重新选择类型',
      importChecking: '正在逐行检查…',
      importReady: '所有行都可以导入，目前还没有写入任何数据。',
      importRejected: '{total} 行中有 {rejected} 行无法导入。改好之前一行都不会导入——导入要么整份成功，要么整份不做。',
      importRowNumber: '行号',
      importRowResult: '结果',
      importRowOk: '可导入',
      importConfirm: '确认导入 {count} 个账号',
      importDone: '已导入 {count} 个账号。'
    }
  },
  tools: {
    // 每个 ClientTool 常量一条。后端只给编码不给名字，工具在工厂里怎么叫，就在这里定。
    name: {
      LIME_STATION_WINDOWS: 'Lime Station（Windows）',
      LIME_STATION_LINUX: 'Lime Station（Linux）',
      LIME_STATION_MACOS: 'Lime Station（macOS）',
      FACTORY_PDA_ANDROID: 'Lime Factory App'
    },
    description: {
      LIME_STATION_WINDOWS:
        '工位电脑上的工作站工具。一个程序承载 PC 侧的作业：CCU 出厂检测，以及 CCU5 烧录。',
      LIME_STATION_LINUX: '同一个工作站工具，为跑 Linux 的工位构建。',
      LIME_STATION_MACOS: '同一个工作站工具，为 macOS 构建 —— 给开发用，不上产线。',
      FACTORY_PDA_ANDROID: '跑在手持机或手机上。三码绑定、整车全检、装箱，三件事在一个 app 里。'
    },
    platform: {
      WINDOWS: 'Windows 电脑',
      ANDROID: 'Android',
      LINUX: 'Linux 电脑',
      MACOS: 'macOS'
    },
    status: {
      DRAFT: '草稿',
      PUBLISHED: '已发布',
      WITHDRAWN: '已撤回'
    },
    downloads: {
      title: '下载',
      subtitle: '你的工位需要的软件，以及该装哪个版本。',
      empty: '当前账号没有可下载的工位软件。如果本该有，请联系管理员。',
      loadFailed: '下载列表加载失败。',
      noRelease: '这个工具还没有发布过版本。',
      mandatory: '必须升级',
      version: '版本',
      published: '发布时间',
      size: '大小',
      checksum: '校验值',
      download: '下载 {name}',
      started: '已开始下载，请在浏览器的下载列表或通知栏查看进度，完成后从那里打开安装包。',
      verifyHint: '文件经由本控制台转发，可能需要几分钟。工具在安装前会用上面的校验值核对文件。'
    },
    releases: {
      title: '版本发布',
      subtitle: '各工位程序当前该装哪个构建。',
      create: '新建版本',
      createTitle: '新建版本',
      editTitle: '修改草稿',
      tool: '程序',
      toolPlaceholder: '选择程序',
      toolRequired: '请选择这是哪个程序的构建。',
      audience: '发布后，所有具备“{permission}”权限的账号都会收到。',
      version: '版本号',
      versionLabel: '版本号',
      versionPlaceholder: '例如 1.4.2',
      versionRequired: '请填写版本号，要和程序自己上报的完全一致。',
      versionHint: '必须与程序自己上报的版本完全一致。在下面选包会自动填上；手填时请从构建产物里复制，不要凭记忆。',
      versionFromPath: '所选的包位于名为 {version} 的文件夹下。',
      versionMismatch:
        '与包所在的文件夹名（{expected}）不一致。填成程序不会上报的版本，所有站点每次检查都会被提示有新版本。',
      versionCode: '构建号',
      versionCodeHint: '数字越大越新。判断新旧看这个，不看版本号文本。',
      versionCodeRequired: '构建号必须是不小于 1 的整数。',
      versionCodeDerived: '按版本号 {version} 推算为 {code}。这个构建若另有编号，改掉即可。',
      versionCodePrevious: '该程序目前最大的构建号是 {code}，对应版本 {version}。',
      versionCodeNotHigher: '不大于 {highest}。构建号不高于现有最大值的包，不会推送给任何站点，也不会报任何错。',
      mismatchConfirmTitle: '保存前请确认',
      mismatchConfirmVersion: '版本号填的是 {typed}，但包所在的文件夹叫 {expected}。',
      mismatchConfirmBuild: '构建号 {typed} 不大于该程序已有的 {highest}。',
      mismatchConfirmTail: '仍然保存吗？',
      saveAnyway: '仍然保存',
      file: '安装包',
      chooseFile: '选择文件',
      noFile: '还没有选择文件。',
      keepingFile: '该构建的安装包是 {name}。要换文件请先丢弃这个草稿，重新上传。',
      fileRequired: '新建版本需要上传安装包。',
      artifact: '构建包',
      sourceStorage: '已构建好的',
      sourceUpload: '上传文件',
      sourceStorageHint: '指定流水线为这个程序产出的构建包。不经过这个页面传输，发布出去的就是构建出来的。',
      sourceUploadHint: '用于流水线之外的构建包。安装包要从这个页面上传，包大的话会比较慢。',
      sourceKey: '构建包',
      sourceKeyPlaceholder: '浏览选择，或粘贴完整路径',
      browseNeedsTool: '请先选择程序，这里只显示它自己的构建包。',
      sourceKeyRequired: '请选择这个版本对应的构建包。',
      browse: '浏览',
      browseTitle: '选择构建包',
      browseName: '名称',
      browseSize: '大小',
      browseModified: '构建时间',
      browseEmpty: '这里没有内容。',
      browseMore: '加载更多',
      browseFailed: '列表加载失败，你仍然可以粘贴完整路径。',
      urgency: '强制升级',
      mandatory: '必须升级',
      optional: '可选',
      mandatoryHint: '打开后，发布之后停留在旧版本的工位不能继续作业。',
      notes: '更新说明',
      notesPlaceholder: '这个构建有哪些操作员需要知道的变化。',
      draftHint: '保存后是草稿。在你点发布之前，工厂那边不会收到任何东西。校验值由服务端在存文件时算出，不需要填。',
      state: '状态',
      downloads: '下载次数',
      publishedAt: '发布时间',
      actions: '操作',
      edit: '修改',
      download: '下载',
      publish: '发布',
      publishConfirmTitle: '确认发布这个构建？',
      publishConfirm: '所有运行该程序的工位都会看到 {version}。',
      publishMandatoryConfirm: '这个构建标记为必须升级，停留在旧版本的工位在装上 {version} 之前不能继续作业。',
      published: '已发布。',
      withdraw: '撤回',
      withdrawConfirmTitle: '确认撤回这个构建？',
      withdrawConfirm: '版本 {version} 将不再提供，并且不能再次发布——请改为发布下一个版本。',
      withdrawn: '已撤回。',
      discard: '丢弃',
      discardConfirmTitle: '确认丢弃这个草稿？',
      discardConfirm: '版本 {version} 及其安装包会一起删除。它没有对外提供过，所以不影响别的东西。',
      discarded: '草稿已丢弃。',
      saved: '已保存为草稿。',
      cancel: '取消',
      save: '保存',
      search: '搜索',
      searchPlaceholder: '版本号或文件名',
      allTools: '全部程序',
      allStatuses: '全部状态',
      allUrgencies: '强制和可选',
      mandatoryOnly: '仅必须升级',
      optionalOnly: '仅可选',
      empty: '还没有任何版本。上传一个构建，工厂那边就有东西可装了。',
      loadFailed: '版本列表加载失败。',
      detailFailed: '该版本详情加载失败。',
      noNotes: '这个构建没有写更新说明。',
      checksum: '校验值：',
      downloadsHeading: '下载记录（{count}）',
      noDownloads: '还没有人下载过这个构建。',
      downloadedBy: '账号',
      downloadedAt: '时间',
      downloadedFrom: '来源地址',
      downloadedWith: '客户端'
    }
  },
  firmware: {
    /** 每个 `FirmwarePackage` 常量一条。后端只给代码，不给名称。 */
    name: {
      CCU5: 'CCU5'
    },
    status: {
      DRAFT: '草稿',
      PUBLISHED: '已发布',
      WITHDRAWN: '已撤回'
    },
    downloads: {
      title: '固件下载',
      subtitle: '发给你链接的那个固件版本。',
      needLink: '请打开发给你的链接',
      needLinkDetail: '固件版本通过 Lime 邮件里的链接下载。如果链接已经失效，请联系 Lime 重新发一个。',
      unavailable: '这个版本无法下载',
      loadFailed: '这个固件版本加载失败。',
      noFiles: '这个版本还没有文件。',
      published: '发布时间',
      file: '文件',
      checksum: '校验值（SHA-256）：',
      downloadNamed: '下载 {name}',
      verifyHint: '文件经由本系统下载，包比较大时可能需要几分钟。烧录前请核对收到的文件与上面的校验值一致。'
    },
    releases: {
      title: '固件发布',
      subtitle: '供应商可以下载哪些固件版本，以及每个版本里的文件。',
      create: '新建版本',
      createTitle: '新建固件版本',
      editTitle: '修改版本',
      package: '固件包',
      packagePlaceholder: '选择固件包',
      packageRequired: '请选择这是哪个固件包的版本。',
      audience: '发布后，所有具备“{permission}”权限的账号都可以下载。',
      version: '版本号',
      versionPlaceholder: '例如 v0.1.5',
      versionRequired: '请填写版本号。',
      versionHint: '按固件团队的命名填写。同一个固件包的版本号不能重复。',
      versionFrozenHint: '版本发布后版本号不能再改，更新说明可以。',
      notes: '更新说明',
      notesPlaceholder: '供应商需要知道的关于这个版本的信息。',
      notesLiveHint: '修改后供应商立刻看到新的文字。',
      draftHint: '保存后是没有文件的草稿。展开它的行添加文件，再发布。发布之前供应商看不到。',
      files: '文件数',
      filesHeading: '文件（{count}）',
      addFile: '添加文件',
      noFiles: '还没有文件。版本至少要有一个文件才能发布。',
      addFileTitle: '添加文件',
      editFileTitle: '修改文件',
      fileTitle: '标题',
      fileTitlePlaceholder: '例如 直接烧录',
      fileTitleHint: '这个文件是做什么用的。供应商会把它当作下载项的标题。',
      fileTitleRequired: '请填写标题。',
      fileDescription: '使用说明',
      fileDescriptionPlaceholder: '什么时候用这个文件，什么时候不用。',
      fileWordsOnlyHint: '只能修改标题和说明。要换文件本身，请发布一个新版本。',
      artifact: '固件文件',
      sourceUpload: '上传文件',
      sourceStorage: '已构建好的',
      sourceUploadHint: '文件从这个页面上传，文件大的话会比较慢。',
      sourceStorageHint: '指定构建任务已经写入存储的文件，不经过这个页面传输。',
      sourceKey: '构建包',
      sourceKeyPlaceholder: '浏览选择，或粘贴完整路径',
      sourceKeyRequired: '请选择这个文件是哪个构建包。',
      browse: '浏览',
      browseTitle: '选择构建包',
      browseName: '名称',
      browseSize: '大小',
      browseModified: '构建时间',
      browseEmpty: '这里是空的。',
      browseMore: '显示更多',
      browseFailed: '列表加载失败，仍可以直接粘贴完整路径。',
      file: '文件',
      chooseFile: '选择文件',
      noFile: '还没有选择文件。',
      fileRequired: '请选择要上传的文件。',
      uploadFailed: '文件没有传到存储。请检查网络后重试；仍然失败请联系管理员。',
      fileAdded: '文件已添加。',
      fileSaved: '文件已保存。',
      fileRemoved: '文件已移除。',
      removeFile: '移除',
      removeFileConfirmTitle: '移除这个文件？',
      removeFileConfirm: '{name} 会从这个草稿里移除。它还没有发给任何人，其他不受影响。',
      state: '状态',
      downloads: '下载次数',
      publishedAt: '发布时间',
      actions: '操作',
      copyLink: '复制链接',
      linkCopied: '链接已复制，可以粘贴到发给供应商的邮件里。',
      linkTitle: '发给供应商的链接',
      close: '关闭',
      download: '下载',
      edit: '修改',
      publish: '发布',
      publishConfirmTitle: '发布这个版本？',
      publishConfirm: '所有可以下载该固件包的账号都能下载 {version} 和其中的所有文件。发布后文件和版本号都不能再改。已发布的其他版本仍然可以下载。',
      published: '已发布。复制链接发给供应商即可。',
      withdraw: '撤回',
      withdrawConfirmTitle: '撤回这个版本？',
      withdrawConfirm: '版本 {version} 将无法再下载，已经发出的链接也会失效。撤回后不能再次发布。',
      withdrawn: '已撤回。',
      discard: '丢弃',
      discardConfirmTitle: '丢弃这个草稿？',
      discardConfirm: '版本 {version} 和它的文件都会被删除。它还没有发给任何人，其他不受影响。',
      discarded: '草稿已丢弃。',
      saved: '草稿已创建。展开它的行添加文件。',
      edited: '已保存。',
      cancel: '取消',
      save: '保存',
      search: '搜索',
      searchPlaceholder: '版本号或文件名',
      allPackages: '全部固件包',
      allStatuses: '全部状态',
      empty: '还没有固件版本。',
      loadFailed: '固件版本加载失败。',
      detailFailed: '这个版本加载失败。',
      noNotes: '这个版本没有填写说明。',
      downloadsHeading: '下载记录（{count}）',
      noDownloads: '还没有人下载这个版本。',
      downloadedBy: '账号',
      downloadedFile: '文件',
      downloadedAt: '时间',
      downloadedFrom: '来源',
      downloadedWith: '程序'
    }
  },
  stock: {
    title: '编码生成',
    description:
      '车架号、VIN 和车牌标签 —— 装一台车需要的编码。它们生成到与老工厂工具同一个号池里，因为打在金属上的编码只能来自一个地方。',
    appendOnly:
      '生成只会往号池里加，这里没有任何操作能收回。批次一旦生成就留在号池里，所以确认前请核对车型、工厂和月份。',
    search: '查询',
    cancel: '取消',
    retry: '重试',
    empty: '还没有生成过。',
    loadFailed: '生成记录加载失败。',
    optionsFailed: '车型和工厂列表加载失败，刷新页面后才能生成。',
    issueFailed: '没有生成任何编码。',
    exportFailed: '编码下载失败。',
    codePlaceholder: '编码或号池',
    orderNoPlaceholder: '订单号',
    anyModel: '全部车型',
    anyFactory: '全部工厂',
    anyMarket: '全部市场',
    pool: '号池',
    model: '车型',
    factory: '工厂',
    productMonth: '生产年月',
    order: '订单',
    orderPlanned: '计划 {quantity}',
    quantity: '数量',
    range: '首尾编码',
    issuedBy: '生成人',
    actions: '操作',
    export: '下载',
    issuedFrame: '已生成 {quantity} 个车架号，{first} 至 {last}。',
    issuedVin: '已生成 {quantity} 个 VIN，{first} 至 {last}。',
    confirm: {
      title: '确认生成这一批？',
      frameBody: '将为 {model} 生成 {quantity} 个车架号，生产年月 {month}，加入号池。无法撤销。',
      vinBody: '将为 {model} 生成 {quantity} 个 VIN，生产年月 {month}，加入号池。无法撤销。',
      issue: '生成'
    },
    form: {
      factory: '工厂',
      frameFactoryHint: '车架在哪里打号。只能选配置了工厂码的工厂。',
      vinFactoryHint: '整车在哪里生产。只能选配置了 VIN 站点码的工厂；站点码相同的工厂共用一个号段。',
      marketHint: '这批车销往哪个市场。它是 VIN 的一部分，生成后无法更改。',
      monthHint: '车辆将在哪个月生产。除非确实如此，一般不是本月 —— 编码是提前发的，而月份决定这批从哪个号段取号。',
      monthOutOfRange: '请填一个接近当前的月份，格式 2026-09。',
      orderNo: '订单号',
      orderNoHint: '选填，原样记录 —— 这里不会去核对是否真有这张订单。不属于任何订单的批次留空即可。',
      orderQuantity: '订单数量',
      orderQuantityHint: '选填。订单计划的数量，只做记录，不限制下面实际生成多少。',
      quantityHint: '单批最多 {max} 个。',
      quantityOutOfRange: '请填 1 到 {max} 之间的数量。',
      submit: '下一步'
    },
    codes: {
      open: '编码',
      frameTitle: '{pool} 的车架号',
      vinTitle: '{pool} 的 VIN',
      code: '编码',
      claimLabel: '被谁占用',
      showSymbol: '显示条码',
      scanUrl: '二维码实际编码的内容',
      scanUrlHint: '工位从车上扫到的网址,不是车牌号',
      symbolTitle: '{code} 的条码',
      placeholder: '编码的任意一段',
      empty: '没有匹配的编码。',
      loadFailed: '编码加载失败。',
      claim: {
        free: '无 —— 可用',
        boundHere: '本系统已绑定的车辆',
        takenInLegacy: '老系统'
      }
    },
    frameBatches: {
      tab: '车架号',
      issue: '生成车架号'
    },
    vinBatches: {
      tab: 'VIN',
      issue: '生成 VIN',
      market: '市场'
    },
    qrImports: {
      tab: '二维码文件',
      import: '导入二维码文件',
      upload: '导入',
      placeholder: '文件名',
      codesTitle: '{file} 里的二维码',
      viewCodes: '查看码',
      anyPosition: '全部位置',
      fileName: '文件',
      position: '位置',
      positionHint: '一个文件对应车上的一个位置，因为每个位置的码都不一样。',
      file: '文件',
      fileHint: '不带表头的 CSV：车牌号、逗号，然后是它的码里包含的网址。',
      chooseFile: '选择文件',
      lines: '行数',
      imported: '已导入',
      duplicate: '已存在',
      importedBy: '导入人',
      skipped: '无法识别',
      done: '导入 {imported} 条。{duplicate} 条已存在，{skipped} 条无法识别。',
      failed: '没有导入任何标签。'
    }
  },
  shipment: {
    line: '行号',
    imei: 'IMEI',
    result: '结果',
    stage: {
      OUTGOING: '出厂',
      INCOMING: '入厂'
    },
    status: {
      PASSED: '合格',
      FAILED: '检测不合格',
      NOT_TESTED: '未完成检测',
      NOT_FOUND: '无记录',
      DUPLICATE: '清单内重复',
      INVALID: 'IMEI 格式错误'
    },
    statusHint: {
      OUTGOING: {
        PASSED: '可以发货。',
        FAILED: '该 CCU 未通过出厂检测，请返修后重新检测。',
        NOT_TESTED: '该 CCU 的出厂检测没有完成，请重新检测。',
        NOT_FOUND: '系统里没有这个 IMEI 的出厂检测记录。请先检测再发货，或核对 IMEI 是否填错。',
        DUPLICATE: '这个 IMEI 已经出现在前面的行里，请删除重复项。',
        INVALID: 'IMEI 必须是 15 位数字。请检查是否丢了开头的 0，或被表格软件改了格式。'
      },
      INCOMING: {
        PASSED: '已准入，可以装车。',
        NOT_FOUND: '该 CCU 尚未准入：没有通过入厂检测，也没有被 Lime 导入准入。请先检测，或核对 IMEI 是否填错。',
        DUPLICATE: '这个 IMEI 已经出现在前面的行里，请删除重复项。',
        INVALID: 'IMEI 必须是 15 位数字。请检查是否丢了开头的 0，或被表格软件改了格式。'
      }
    },
    check: {
      title: 'CCU 清单核对',
      description:
        '上传 CCU IMEI 清单。出厂检账号上传准备发货的清单，对照出厂检测记录核对；入厂检账号上传收到的清单，对照已准入装车的 CCU 核对。所有未通过核对的 IMEI 都会列出来。',
      chooseFile: '选择文件',
      downloadTemplate: '下载模板',
      fileHint:
        '支持 .xlsx 和 .csv，第一列每行一个 IMEI，表头行（写 IMEI 或 SN）可有可无。建议使用模板：模板的 IMEI 列已设为文本格式，Excel 不会把 IMEI 变成科学计数法。',
      submit: '开始核对',
      chooseFirst: '请先选择文件。',
      failed: '清单核对失败，没有留下任何记录。',
      allClear: '清单中的 {count} 个 IMEI 全部通过核对。',
      notClear: '{count} 行中有 {problems} 行未通过核对。',
      onlyPassed: {
        OUTGOING: '只有“合格”的 IMEI 才能发货。请处理或删除其余各行，然后重新核对。',
        INCOMING: '只有“合格”的 IMEI 才能装车。其余的请先单独放置，处理后重新核对。'
      },
      export: '导出结果',
      whatToDo: '处理建议'
    },
    manifests: {
      title: 'CCU 清单核对记录',
      description:
        '各工厂核对过的每一份 CCU 清单（出厂和入厂），以及每一行的核对结果。这是各工厂声称发出或收到内容的记录，工厂账号看不到。',
      fileNamePlaceholder: '文件名',
      operatorPlaceholder: '提交人',
      imeiPlaceholder: 'IMEI',
      anyStage: '出厂和入厂',
      search: '搜索',
      retry: '重试',
      loadFailed: '核对记录加载失败。',
      itemsFailed: '该次核对的明细加载失败。',
      empty: '还没有核对过任何清单。',
      itemsEmpty: '没有符合条件的行。',
      file: '文件',
      stage: '核对类型',
      where: '工厂',
      lines: '行数',
      passed: '合格',
      toResolve: '待处理',
      checkedAt: '核对时间（UTC）',
      open: '明细',
      anyStatus: '全部结果',
      attempt: '依据记录',
      detailTotals: '共 {lines} 行，{problems} 行未通过'
    }
  },
  legacy: {
    title: '老系统码库',
    description:
      '老系统已发放的车架号、VIN 和已打印的车牌二维码，以及它已经绑定过的车辆。绑定时扫的每个码都来自上游发放，本服务无法自己造一个，所以测试要用的真码从这里来——以对应二维码的图形显示，可以直接对着屏幕扫。',
    readOnly:
      '这几张表属于老系统。本页面只读，任何操作都不会改动其中的行。它对「码是否可用」的判断只代表它自己——在本服务里已绑定的码在这里仍显示为未使用，只有绑定校验才同时对两边负责。',
    search: '搜索',
    symbolTitle: '{label} · {code}',
    scanCue: '点击任一编码，可放大成扫码枪能读的符号。',
    state: '状态',
    anyState: '全部状态',
    freeOnly: '仅未使用',
    issuedAt: '发放时间',
    empty: '没有匹配的记录。',
    loadFailed: '列表加载失败。',
    retry: '重试',
    stockState: {
      FREE: '未使用',
      TAKEN: '已使用'
    },
    bindingState: {
      LIVE: '已绑定',
      RELEASED: '已解绑'
    },
    frameNumbers: {
      tab: '车架号',
      frameNumber: '车架号',
      placeholder: '车架号前缀',
      label: 'RFID 标签',
      labelWritten: '已写入',
      labelNotWritten: '未写入',
      codesTitle: '车架号 {code}',
      codeHint: '打在车架上，以一维条形码读取。'
    },
    vinCodes: {
      tab: 'VIN',
      vinCode: 'VIN',
      placeholder: 'VIN 前缀',
      claimedBy: '已被该车架占用',
      codesTitle: 'VIN {code}',
      codeHint: 'VIN 由车架占用，已占用的 VIN 不能再给另一台车。'
    },
    qrCodes: {
      tab: '车牌二维码',
      plateNumber: '车牌号',
      scanUrl: '二维码实际编码的内容',
      placeholder: '车牌号前缀',
      codesTitle: '二维码 {code}',
      positionColumn: '贴在哪里',
      positionUnknown: '未记录',
      position: {
        plate: '车牌',
        fender: '挡泥板',
        down_tube: '下管',
        Cart: '料车'
      },
      codeHint: '扫出来的是这个 URL，不是车牌号本身。工位工具原样上报它。'
    },
    bindings: {
      tab: '老系统已绑定',
      imei: '模块',
      plateNumber: '车牌号',
      frameNumber: '车架号',
      skuCode: 'SKU',
      boundAt: '绑定时间',
      imeiPlaceholder: 'IMEI 前缀',
      framePlaceholder: '车架号前缀',
      platePlaceholder: '车牌号前缀',
      anyState: '含已解绑',
      liveOnly: '仅已绑定',
      vinCode: 'VIN',
      opsBikeId: 'Bike ID',
      notSynced: '未同步',
      plateQrCode: '车牌二维码 — {position}',
      codesTitle: '车辆 {plate}'
    }
  },
  // 后端定义的每个权限的中文说明。权限字符串本身才是契约，所以缺少条目时直接显示原始编码，
  // 而不是显示空白——见 RoleListView 里的 permissionLabel。
  permission: {
    'acceptance:standard:read': '查看验收标准',
    'acceptance:standard:write': '编辑验收标准',
    'acceptance:standard:resolve': '拉取当前生效的标准（工位工具）',
    'product:model:read': '查看车型',
    'product:model:write': '编辑车型',
    'product:sku:read': '查看 SKU',
    'product:sku:write': '编辑 SKU',
    'eol:record:read': '查看验收记录',
    'identity:ccu:read': '查看 CCU 云身份',
    'identity:ccu:admit': '免检验准入 CCU 模块',
    'stock:code:read': '查看已生成的编码批次',
    'stock:code:issue': '生成车架号和 VIN，导入二维码',
    'shipment:ccu:check': '核对 CCU 清单',
    'shipment:ccu:read': '查看所有 CCU 清单核对记录',
    'legacy:code:read': '查看老系统已发放的各类码',
    'tool:release:read': '查看工位软件版本',
    'tool:release:write': '发布工位软件',
    'firmware:release:read': '查看固件版本',
    'firmware:release:write': '发布固件',
    'firmware:ccu5:download': '下载 CCU5 固件',
    'sop:ccu:outgoing': '查看 CCU5 熔丝关闭与出厂检作业指导书',
    'sop:ccu:incoming': '查看 CCU 入厂检作业指导书',
    'sop:vehicle:binding': '查看三码绑定作业指导书',
    'sop:vehicle:static': '查看整车静态检测作业指导书',
    'sop:vehicle:ride': '查看整车骑行测试作业指导书',
    'sop:shipment:ccu': '查看 CCU 清单核对作业指导书',
    'eol:ccu:test': '上报 CCU 验收结果',
    'eol:vehicle:static': '执行静态检测',
    'eol:vehicle:ride': '执行骑行测试',
    'provision:ccu:read': '查看烧录工位的记录',
    'provision:ccu:flash': '给 CCU 板刷入生产固件',
    'provision:ccu:fuse': '烧写 CCU 板的生产密钥并封板',
    'ops:vehicle:command': '给车辆下发指令',
    'ops:vehicle:advanced': '给车辆下发高级指令',
    'ops:vehicle:read': '查看给车辆下发过的指令',
    'ops:ccu:bench': '在工位上用数据线操作 CCU',
    'ops:ccu:deploy': '给数据线连着的 CCU 推送本地编译的固件',
    'ops:chirp:mint': '铸造车辆通信凭证',
    'binding:vehicle:read': '查看车辆绑定记录',
    'binding:vehicle:write': '扫码绑定整车',
    'binding:vehicle:unbind': '解绑整车',
    'binding:vehicle:console': '在后台绑定和解绑整车',
    'iam:app:access': '从手持端 App 登录',
    'iam:pc:access': '从工位工具登录',
    'iam:console:access': '登录管理后台',
    'iam:operator:read': '查看操作员账号',
    'iam:operator:write': '编辑操作员账号',
    'iam:organisation:read': '查看工厂',
    'iam:organisation:write': '编辑工厂',
    'iam:role:read': '查看角色',
    'iam:role:write': '编辑角色及其权限',
    'iam:audit:export': '下载用户访问审查表和角色设计审查表'
  },
  /** 去掉动作后的权限编码——角色页上一个分组的标题。 */
  permissionResource: {
    'acceptance:standard': '验收标准',
    'product:model': '车型',
    'product:sku': 'SKU',
    'eol:record': '验收记录',
    'identity:ccu': 'CCU 云身份',
    'stock:code': '编码生成',
    'shipment:ccu': 'CCU 清单',
    'legacy:code': '老系统码库',
    'tool:release': '工位软件',
    'firmware:release': '固件发布',
    'firmware:ccu5': 'CCU5 固件',
    'sop:ccu': 'CCU 作业指导书',
    'sop:vehicle': '整车作业指导书',
    'sop:shipment': 'CCU 清单作业指导书',
    'eol:ccu': 'CCU 验收',
    'eol:vehicle': '整车验收',
    'provision:ccu': 'CCU 烧录',
    'ops:vehicle': '车辆指令',
    'ops:ccu': 'CCU 工位',
    'ops:chirp': '车辆通信凭证',
    'binding:vehicle': '整车绑定',
    'iam:app': '手持端 App',
    'iam:pc': '工位工具',
    'iam:console': '管理后台',
    'iam:operator': '操作员',
    'iam:organisation': '工厂',
    'iam:role': '角色',
    'iam:audit': '访问审查'
  },
  /** 权限编码的最后一段——分组内的勾选项文案，资源名已经在分组标题上了。 */
  permissionAction: {
    export: '导出',
    command: '下发指令',
    read: '查看',
    write: '编辑',
    resolve: '拉取（工位）',
    test: '上报',
    static: '静态检测',
    ride: '骑行测试',
    unbind: '解绑',
    check: '核对清单',
    issue: '生成',
    mint: '铸造',
    flash: '刷机',
    fuse: '烧写密钥并封板',
    bench: '下发指令',
    deploy: '推送固件',
    access: '登录',
    download: '下载',
    incoming: '入厂检',
    outgoing: '熔丝关闭与出厂检',
    binding: '三码绑定'
  },
  help: {
    sops: {
      title: '作业指导书',
      description: '本账号所在工位的作业指导书（SOP）。只列出与本账号权限有关的文件。',
      empty: '这个账号没有需要查看的作业指导书。',
      open: '查看',
      documentNo: '文件编号',
      version: '版本',
      issued: '发布日期'
    },
    sop: {
      print: '打印',
      back: '返回列表',
      notFound: '没有这份作业指导书，或者这个账号不能查看它。',
      ccu5FuseOutgoing: {
        title: 'CCU5 熔丝关闭与出厂检测',
        description: '供应商产线上由 Lime 负责的两道工序：裸板熔丝并关闭，装壳后出厂检测。'
      },
      ccu5Incoming: {
        title: 'CCU5 入厂检测',
        description: '整车厂收到 CCU5 后，装车前逐台检测并登记身份数据。'
      },
      vehicleBinding: {
        title: '三码绑定',
        description: '用手持终端把车辆二维码、车架号和 CCU 的 IMEI 绑成一条记录。'
      },
      vehicleStatic: {
        title: '整车静态检测',
        description: '用手持终端读取整车上报的数据，并完成需要人确认的检查项。'
      },
      ccuListCheck: {
        title: 'CCU 清单核对',
        description: 'CCU 厂发货前、整车厂收货后，把 CCU 的 IMEI 清单上传到控制台核对，只有“合格”的 CCU 才能发货或装车。'
      },
      vehicleRide: {
        title: '整车骑行测试',
        description: '用手持终端开始骑行测试，按提示骑行，等待后台给出结论。'
      }
    }
  },
  forbidden: {
    heading: '没有权限',
    text: '你的账号不具备访问该页面所需的角色。如确实需要，请联系管理员。'
  },
  error: {
    'identity.ccu.register.unavailable': 'Chirp 服务账号未登录，且本部署无法自动登录。请先在车辆通信凭证页面手动登录。',
    'identity.ccu.register.unreachable': '连不上 Chirp 车辆注册服务，未做任何更改。请几分钟后重试。',
    'identity.ccu.register.key_revoked': '这把公钥已在 Chirp 被吊销，吊销是永久的，这个 CCU 不能再用它注册。',
    'identity.ccu.register.held_by_unknown_key': 'Chirp 中这个 IMEI 登记的是另一把公钥，而且不是这个 CCU 报告过的。未做任何更改，请联系 IoT 确认它属于哪台设备。',
    'identity.ccu.register.replace_required': 'Chirp 中仍登记着这个 CCU 之前的公钥。注册新公钥会永久吊销旧公钥。',
    'identity.ccu.register.key_on_another_imei': 'Chirp 中这把公钥登记在另一个 IMEI 下，未做任何更改。',
    'identity.ccu.register.not_allowed': 'Chirp 服务账号没有注册真车的权限，请联系 IoT 添加。',
    'identity.ccu.register.key_invalid': 'Chirp 不接受这个公钥，请重新测试这个 CCU 读取公钥。',
    'identity.ccu.register.refused': 'Chirp 车辆注册服务拒绝了这次注册，未做任何更改。',
    'export.too_many_rows': '符合当前筛选条件的记录超过单次导出的上限，请缩小筛选范围后再导出。',
    'shipment.manifest.file.empty': '文件里没有 IMEI，请确认 IMEI 在第一列。',
    'shipment.manifest.file.unsupported': '只支持核对 .xlsx 和 .csv 文件。',
    'shipment.manifest.file.unreadable': '文件无法读取，请另存为 .xlsx 或 .csv 后重新上传。',
    'shipment.manifest.too_many_lines': '这份清单的行数超过单次校验的上限，请拆分成多个文件。',
    'shipment.manifest.not_found': '没有这条核对记录。',
    'network.unreachable': '无法连接服务器。',
    'internal.error': '服务端出错了。',
    'auth.credentials.invalid': '用户名或密码错误。',
    'auth.credentials.locked': '密码错误次数过多，该账号的密码登录已暂停。请稍后再试，或联系管理员解锁。',
    'auth.required': '请先登录。',
    'auth.forbidden': '没有执行该操作的权限。',
    'auth.organisation.disabled': '所在工厂已被禁用，无法登录。',
    'auth.client.not_allowed': '该账号没有管理后台的访问权限。',
    'iam.organisation.not_found': '工厂不存在。',
    'iam.organisation.code.duplicate': '该工厂编码已存在。',
    'iam.organisation.frame_code.duplicate': '该车架码已存在。',
    'iam.operator.not_found': '账号不存在。',
    'iam.operator.username.duplicate': '该用户名已存在。',
    'iam.operator.google_email.duplicate': '该邮箱已授权给其他账号。',
    'iam.operator.role.unknown': '角色编码不存在。',
    'iam.operator.organisation.unknown': '工厂编码不存在。',
    'iam.operator.self_disable': '不能禁用当前登录的账号。',
    'iam.operator.self_role_change': '不能修改当前登录账号的角色。',
    'iam.operator.password.too_short': '密码至少需要 14 个字符。',
    'iam.operator.password.too_long': '密码太长：英文字母或数字最多 72 个，中文最多 24 个。',
    'iam.operator.password.contains_username': '密码不能包含用户名。',
    'iam.operator.password.common': '该密码过于常见或容易被猜到，请换一个不以常见单词为基础的较长短语。',
    'iam.operator.password.reused': '该账号曾经使用过这个密码，请换一个新密码。',
    'iam.operator.import.malformed': '该文件无法按 CSV 解析，常见原因是有一个引号没有闭合。',
    'iam.operator.import.header': '首行的列名与所选导入类型不符。请确认类型是否选对，不确定就下载模板。',
    'iam.operator.import.empty': '该文件表头之下没有任何数据行。',
    'iam.operator.import.too_many_rows': '该文件的行数超过单次导入的上限，请拆分文件。',
    'iam.operator.import.columns': '该行的列数与表头不一致。',
    'iam.operator.import.username.required': '没有填用户名。',
    'iam.operator.import.username.duplicated': '本文件中另有一行用了这个用户名。',
    'iam.operator.import.role.required': '没有填角色。',
    'iam.operator.import.organisation.required': '没有填所属工厂。',
    'iam.operator.import.password.required': '没有填密码。',
    'iam.operator.import.email.required': '没有填邮箱。',
    'iam.operator.import.email.invalid': '这不是一个邮箱地址。',
    'iam.operator.import.email.duplicated': '本文件中另有一行用了这个邮箱。',
    'iam.operator.import.value.too_long': '该行有一个值超出了对应列允许的长度。',
    'iam.role.not_found': '角色不存在。',
    'iam.role.code.duplicate': '该角色编码已存在。',
    'iam.role.code.immutable': '角色编码不可修改。',
    'iam.role.permission.unknown': '该权限不是本服务定义的权限。',
    'iam.role.permission.wildcard_reserved': '「全部权限」仅属于 ADMINISTRATOR 角色。',
    'iam.role.administrator.wildcard_required': 'ADMINISTRATOR 角色必须保留全部权限，否则将无人能进行管理操作。',
    'tool.release.not_found': '该版本已不存在，请刷新列表。',
    'tool.release.version.duplicate': '该程序已有同样版本号的构建。',
    'tool.release.version_code.duplicate': '该程序已有同样构建号的构建。',
    'tool.release.not_draft': '该构建已经发布过，不能再修改也不能删除。请先撤回，然后发布下一个版本。',
    'tool.release.status.transition': '草稿可以发布，已发布的可以撤回，不能反向操作。',
    'tool.release.not_published': '该构建尚未发布，无法下载。',
    'firmware.release.not_found': '找不到这个固件版本。如果你是从链接进来的，请联系 Lime 重新发一个；否则请刷新列表。',
    'firmware.release.version.duplicate': '该固件包已有这个版本号。',
    'firmware.release.not_draft': '该版本已经发布，不能再增删文件，也不能丢弃。请撤回后发布一个新版本。',
    'firmware.release.version.frozen': '已发布的版本不能再改版本号，更新说明还可以改。',
    'firmware.release.withdrawn': '该版本已撤回，不能再编辑。',
    'firmware.release.no_artifacts': '请先添加至少一个文件再发布。',
    'firmware.artifact.not_found': '这个版本里没有这个文件，请刷新后重试。',
    'firmware.artifact.name.duplicate': '这个版本里已经有同名文件。',
    'firmware.release.status.transition': '草稿可以发布，已发布的可以撤回，不能反向操作。',
    'firmware.release.not_published': '该版本已撤回或尚未发布，无法下载。',
    unknown: '未知错误。'
  },
  notFound: {
    heading: '页面不存在',
    back: '返回概览'
  },
  listExport: {
    button: '导出',
    failed: '导出失败，请重试。'
  },
  language: {
    label: '语言',
    en: 'English',
    zh: '中文'
  }
}
